import { Swiper, SwiperSlide } from 'swiper/react'
import { Autoplay, Pagination } from 'swiper/modules'
import 'swiper/css'
import 'swiper/css/pagination'
import { useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { RootState } from '../../redux-stores/store'
import { Ticker as TickerItemType } from '../../redux-stores/slices/authSlice'
import ColorfullWhatsAppIcon from '../../assets/icons/ColorfullWhatsAppIcon'
import './HomepageTicker.scss'

const isWhatsappTicker = (title: string) => title.toLowerCase().includes('whatsapp')

const HomepageTicker = () => {
    const tickers = useSelector((state: RootState) => state.auth.user?.tickers)
    const navigate = useNavigate()

    const slideClickHandler = (item: TickerItemType) => {
        if (!item.url) return
        if (item.url.includes('http')) {
            window.open(item.url, '_blank', 'noopener,noreferrer')
        } else {
            navigate(item.url)
        }
    }

    if (!Array.isArray(tickers) || tickers.length === 0) return null

    const hasMultiple = tickers.length > 1

    return (
        <Swiper
            modules={[Autoplay, Pagination]}
            className="homepage-ticker__swiper"
            loop={hasMultiple}
            spaceBetween={16}
            autoplay={
                hasMultiple
                    ? {
                          delay: 5000,
                          disableOnInteraction: false,
                      }
                    : false
            }
            pagination={hasMultiple ? { clickable: true, dynamicBullets: true } : false}
        >
            {tickers.map((item, i) => {
                const showWhatsappIcon = isWhatsappTicker(item.title)
                const interactive = Boolean(item.url)
                return (
                    <SwiperSlide key={`${item.title}-${item.url}-${i}`}>
                        <div
                            className="homepage-ticker__card"
                            onClick={() => (interactive ? slideClickHandler(item) : undefined)}
                            onKeyDown={(e) => {
                                if (!interactive) return
                                if (e.key === 'Enter' || e.key === ' ') {
                                    e.preventDefault()
                                    slideClickHandler(item)
                                }
                            }}
                            role={interactive ? 'button' : undefined}
                            tabIndex={interactive ? 0 : undefined}
                            aria-label={interactive ? `${item.title}. ${item.description}` : undefined}
                        >
                            {showWhatsappIcon && (
                                <div className="homepage-ticker__icon" aria-hidden>
                                    <ColorfullWhatsAppIcon />
                                </div>
                            )}
                            <div className="homepage-ticker__text">
                                <p className="homepage-ticker__title">{item.title}</p>
                                <p className="homepage-ticker__description">{item.description}</p>
                            </div>
                            {item.cta_text ? (
                                <span className="homepage-ticker__cta text-truncate">{item.cta_text}</span>
                            ) : (
                                <div className="homepage-ticker__action" aria-hidden>
                                    <i className="fa-solid fa-chevron-right" />
                                </div>
                            )}
                        </div>
                    </SwiperSlide>
                )
            })}
        </Swiper>
    )
}

export default HomepageTicker
